import { z } from "zod";

import { zNonEmptyString } from "../../common/util";

export const zAccountInfoSchema = z.object({
  account_number: zNonEmptyString,
  tax_id: zNonEmptyString,
});

export type AccountInfoSchema = z.infer<typeof zAccountInfoSchema>;
